/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const BookmarkX = [
  ["path", { d: "m14.5 7.5-5 5" }],
  [
    "path",
    {
      d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z"
    }
  ],
  ["path", { d: "m9.5 7.5 5 5" }]
];

export { BookmarkX as default };
//# sourceMappingURL=bookmark-x.js.map
